import { GoldExpSystem } from '../../../domain/goldExpSystem.js';
import { updateBuffs } from '../../../domain/jungle.js';
import { applyAramGlobalAura, updateAramGlobalRegen } from '../../../domain/map/aramRules.js';

const ARAM_MAP_ID = 'aram_proving_grounds';
const DEFAULT_PASSIVE_GOLD_RATE = 2.5;

function applyAramTickToChampions(champions, dt) {
  for (const champ of champions) {
    if (!champ || champ.isDead) continue;
    const aura = applyAramGlobalAura(champ);
    champ.outgoingHealingMultiplier = aura.outgoingHealingMultiplier;
    champ.aramAuraActive = aura.aramAuraActive;
    const regen = updateAramGlobalRegen(champ, dt);
    champ.hp = regen.hp;
    champ.mp = regen.mp;
  }
}

function livingChampions(champions) {
  return champions.filter(
    (c) => c && !c.isDead && c.type === 'champion' && !c.isPassive
  );
}

function applyPassiveGoldToChampions(champions, dt, passiveGoldRate) {
  for (const champ of livingChampions(champions)) {
    GoldExpSystem.applyPassiveGold(champ, dt, passiveGoldRate);
  }
}

function applyPassiveXpToChampions(champions, dt, passiveXpRate) {
  for (const champ of livingChampions(champions)) {
    GoldExpSystem.applyPassiveXp(champ, dt, passiveXpRate);
  }
}

/**
 * Buffs, passive gold/XP (map plan rates), and ARAM global aura/regen.
 */
export function updateBuffsAndGold({
  championEntity,
  secondaries = [],
  dt = 0,
  mapId = null,
  passiveGoldRate = DEFAULT_PASSIVE_GOLD_RATE,
  passiveXpRate = 0
} = {}) {
  if (!championEntity) return;
  updateBuffs(championEntity, dt);
  const champs = [championEntity, ...secondaries];
  const goldRate = Number.isFinite(passiveGoldRate) ? passiveGoldRate : DEFAULT_PASSIVE_GOLD_RATE;
  const xpRate = Number.isFinite(passiveXpRate) ? passiveXpRate : 0;
  applyPassiveGoldToChampions(champs, dt, goldRate);
  applyPassiveXpToChampions(champs, dt, xpRate);
  if (mapId !== ARAM_MAP_ID) return;
  const aramChamps = livingChampions(champs);
  applyAramTickToChampions(aramChamps, dt);
}
